import { POLL_IDLE_MS, POLL_RUNNING_MS } from '@/constants/sync';

/** Quick while something is in progress, so a run is seen finishing; slow otherwise. */
export const pollInterval = (anythingRunning: boolean): number =>
  anythingRunning ? POLL_RUNNING_MS : POLL_IDLE_MS;
